/**
 * Debug/diagnostics gate for the AP app.
 *
 * Raw Graph diagnostics (Graph errors, identity forms, record counts) help
 * admins onboard APs but must NOT be shown to AP guests in production. The gate
 * is enabled when:
 *   - this is a dev build (`import.meta.env.DEV`), or
 *   - the URL carries `?debug=1` — also persisted to localStorage so it
 *     survives the reload that ProfileSetupNotice's "Try again" triggers, or
 *   - localStorage `ap_debug` === '1'.
 *
 * Pass `?debug=0` to turn it back off.
 */
export function isDebugEnabled(): boolean {
  if (import.meta.env.DEV) return true;

  try {
    const debugParam = new URLSearchParams(window.location.search).get('debug');
    if (debugParam === '1') {
      window.localStorage.setItem('ap_debug', '1');
      return true;
    }
    if (debugParam === '0') {
      window.localStorage.removeItem('ap_debug');
      return false;
    }
    return window.localStorage.getItem('ap_debug') === '1';
  } catch {
    return false;
  }
}
